const ecCurveNames = [
  'secp224r1',
  'prime256v1',
  'secp384r1',
  'secp521r1',
  'brainpoolP224r1',
  'brainpoolP256r1',
  'brainpoolP320r1',
  'brainpoolP384r1',
  'brainpoolP512r1',
  'secp224k1',
  'secp256k1',
  'sect233k1',
  'sect233r1',
  'sect239k1',
  'sect283k1',
  'sect283r1',
  'sect409k1',
  'sect409r1',
  'sect571k1',
  'sect571r1',
  'c2tnb239v1',
  'c2tnb239v2',
  'c2tnb239v3',
  'c2pnb272w1',
  'c2pnb304w1',
  'c2tnb359v1',
  'c2pnb368w1',
  'c2tnb431r1',
  'brainpoolP224t1',
  'brainpoolP256t1',
  'brainpoolP320t1',
  'brainpoolP384t1',
  'brainpoolP512t1',
  'sphincs-sha2-128f'
]

export default ecCurveNames
